import { graphql } from "../../gql";

export const GAME_ADD_RATING = graphql(`
  mutation GameAddRating($gameId: String!, $rating: Int!) {
    gameAddRating(gameId: $gameId, rating: $rating) {
      id
    }
  }
`);
